import { api as generatedApi } from 'gen/rtk-openapi'
import { Auth } from 'aws-amplify'
import { GetObjectCommand, HeadObjectCommand, S3Client } from '@aws-sdk/client-s3'
import { getSignedUrl } from '@aws-sdk/s3-request-presigner'
import store from 'state/store'

const TAG_TYPES = {
  assets: 'Assets',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.assets],
  endpoints: {
    getOrgImage: {
      providesTags: (result, error, { filename }) => [
        {
          type: TAG_TYPES.assets,
          id: filename,
        },
      ],
    },
    captureImage: {},
    uploadOrgImage: {},
    getLicenseInfo: {},
  },
})

async function existsOnS3(client, bucket, key) {
  try {
    const bucketParams = {
      Bucket: bucket,
      Key: key,
    }
    const cmd = new HeadObjectCommand(bucketParams)
    await client.send(cmd)

    return true
  } catch (error) {
    if (error.$metadata?.httpStatusCode === 404) {
      // doesn't exist and permission policy includes s3:ListBucket
      console.error('S3 Object does not exist: ', error)
      return false
    } else if (error.$metadata?.httpStatusCode === 403) {
      // doesn't exist, permission policy WITHOUT s3:ListBucket
      console.error('Access denied while checking if image exists on S3: ', error)
      return false
    } else {
      // some other error
      console.error('Unexpected error during S3 HeadObject check: ', error)
      return false
    }
  }
}

export const getImageUrl = async (fileName, logoImage, options = {}) => {
  const state = store.getState()
  const organization = state?.auth?.organization

  if (!organization) {
    console.error('Organization not found in state')
    return null
  }

  const credentials = await Auth.currentCredentials()
  const essentialCreds = Auth.essentialCredentials(credentials)

  const s3Client = new S3Client({
    region: 'us-east-2',
    credentials: {
      accessKeyId: essentialCreds.accessKeyId,
      secretAccessKey: essentialCreds.secretAccessKey,
      sessionToken: essentialCreds.sessionToken,
    },
  })

  const bucketName = `gs-org-images-${process.env.REACT_APP_STAGE}`
  const key = `${organization}/${fileName}`

  try {
    const exists = await existsOnS3(s3Client, bucketName, key)

    if (!exists) {
      return logoImage // Return default logo image if the file does not exist
    }

    const signedUrl = await getSignedUrl(s3Client, new GetObjectCommand({ Bucket: bucketName, Key: key }), {
      expiresIn: 3600,
      ...options,
    })
    return signedUrl
  } catch (error) {
    console.error('Error while fetching with S3 image: ', error)
    return logoImage // Return default logo image in case of any other error
  }
}

export const { useUploadOrgImageMutation, useGetOrgImageQuery, useCaptureImageMutation, useGetLicenseInfoMutation } =
  api
